<template>
    <div class="bg-white rounded shadow min-h-screen">
        <div class="flex-col flex gap-4">
            <div class="p-4 bg-white gap-4 flex rounded-lg">
                <button
                    @click="changeIsArchived(false)"
                    class="text-main2 border-1 border-main2 py-3 px-5 rounded hover:bg-main2 hover:text-white10"
                    :class="{'bg-main2 text-white10': !isArchived}"
                >
                    Onlayn buyurtma
                </button>
                <button
                    @click="changeIsArchived(true)"
                    class="text-main2 border-1 border-main2 py-3 px-5 rounded hover:bg-main2 hover:text-white10"
                    :class="{'bg-main2 text-white10': isArchived}"
                >
                    Buyurtmalar tarixi
                </button>
            </div>
            <div class="bg-white rounded-lg shadow-[4px_10px_10px_0_#DCE7FF]">
                <div class="overflow-x-auto px-4" v-if="isArchived && !isLoadingOrders">
                    <ListOrdersArchives :orders="this.getOrdersCustomer.models" />
                </div>
                <div class="overflow-x-auto px-4" v-if="!isArchived && !isLoadingOrders">
                    <ListOrders :orders="this.getOrdersCustomer.models" @changeStatus="changeStatus" @changeDeliveredAt="changeDeliveredAt" />
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import accessMixin from "@/mixin/accessMixin"
import dateFormatting from "@/mixin/dateFormattingMixin"
import ListOrders from "../../components/ListOrders.vue"
import ListOrdersArchives from "@/components/ListOrdersArchives.vue";

export default {
    name: "OrdersPage",
    components: {ListOrdersArchives, ListOrders},
    mixins: [dateFormatting, accessMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'sale.title', url: 'sales/sale'},
                {name: 'order.onlineOrder', url: 'sales/orders'}
            ],
            isLoading: false,
            isLoadingOrders: false,
            isArchived: false,
            search: {
                page: 1
            },
            modelForm: {
                percent: '',
                name: '',
                company: ''
            },
        }
    },
    computed: {
        ...mapGetters(['getOrdersCustomer']),
    },
    methods: {
        ...mapActions([
            'fetchAllTaxes',
            'setBreadcrumbItems',
            'pushTax',
            'putTax',
            'fetchOrdersCustomer',
            'changeOrderStatus',
            'changeOrderDeliveredAt'
        ]),
        addTax() {
            this.$root.showOverlay = true
            this.isLoading = true

            if (this.$route.name === "sales/taxes/edit") {
                this.putTax(this.modelForm)
                    .then(() => {
                        this.$root.showOverlay = false
                        this.isLoading = false
                        this.fetchAllTaxes()
                        this.$i18nHelper.toUrl('sales/taxes')
                        this.$bvModal.hide('addTax')
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                        this.isLoading = false
                        this.$bvModal.hide('addTax')
                    })
            } else {
                this.pushTax(this.modelForm)
                    .then(() => {
                        this.$root.showOverlay = false
                        this.fetchAllTaxes()
                        this.isLoading = false
                        this.$bvModal.hide('addTax')
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                        this.isLoading = false
                        this.$bvModal.hide('addTax')
                    })
            }
        },
        changeStatus(order) {
            this.changeOrderStatus(order)
                .then(() => this.fetchOrdersCustomer())
        },
        changeDeliveredAt(order) {
            this.changeOrderDeliveredAt(order)
                .then(() => this.fetchOrdersCustomer())
        },
        changeIsArchived(isArchived) {
            this.isLoadingOrders = true
            this.isArchived = isArchived
            this.fetchOrdersCustomer(isArchived)
                .then(() => this.isLoadingOrders = false)
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchOrdersCustomer()
    }
}
</script>

<style scoped>

</style>
